import { classNames } from "shared/lib/classNames/classNames";
import cls from "./AppLink.module.scss";
import {ComponentProps, FC} from "react";

export enum AppLinkTheme {
    PRIMARY = "primary",
    SECONDARY = "secondary"
}

interface AppLinkProps extends ComponentProps<"a"> {
    className?: string;
    isActive?: boolean;
    theme?: AppLinkTheme;
}

export const AppLink: FC<AppLinkProps> = (props) => {
    const {
        className,
        href,
        isActive,
        children,
        theme = AppLinkTheme.PRIMARY,
        ...rest
    } = props;
    return (
        <a
            href={href}
            className={classNames(cls.AppLink, {
                [cls.AppLink_active]: isActive
            }, [className, cls[theme]])}
            {...rest}
        >
            {children}
        </a>
    )
};



